import { BroadcastChannel } from 'broadcast-channel';

export const YandexHandler = () => {
  const searchQuery = window.location.hash.replace('#', '?');
  const searchParams = new URLSearchParams(searchQuery);
  const token = searchParams.get('access_token');
  const expiresIn = searchParams.get('expires_in');
  const state = searchParams.get('state');
  const error = searchParams.get('error');

  /**
   * Обработчик для Яндекс авторизации с редиректом (когда есть state)
   */
  const handleRedirectFlow = () => {
    let targetPath = '/';
    try {
      const decodedState = decodeURIComponent(state || '');
      targetPath = decodedState || '/';
    } catch {
      targetPath = '/';
    }

    const newUrl = new URL(`${window.location.origin}${targetPath}`);

    if (token && expiresIn) {
      newUrl.searchParams.set('access_token', token);
      newUrl.searchParams.set('expires_in', expiresIn);
    } else {
      const errorMessage = error || 'auth_failed';
      newUrl.searchParams.set('error', errorMessage);
    }

    window.location.replace(newUrl.toString());
  };

  /**
   * Обработчик для Яндекс авторизации в обычном браузере (попап)
   */
  const handleBrowserFlow = () => {
    const channel = new BroadcastChannel('auth-yandex-code');

    if (token) {
      channel.postMessage({
        access_token: token,
        expires_in: expiresIn,
        success: true,
      });
    } else {
      const errorObj = {};
      searchParams.forEach((value, key) => {
        errorObj[key] = value;
      });
      channel.postMessage({
        success: false,
        error: errorObj,
      });
    }

    setTimeout(() => {
      window.close();
    }, 250);
  };

  if (state) {
    handleRedirectFlow();
  } else {
    handleBrowserFlow();
  }
};
